import { FC } from 'react';

export const ResetPasswordBackground: FC = () => {
  return (
    <div className='h-screen w-full relative bg-[#fff] rounded-es-[10dvh] rounded-ss-[10dvh]'>
      <img className='absolute top-[10px] left-0 bottom-0 w-full object-cover min-h-full' src='/postel_rectangle.svg' />
    </div>
  );
};
